module.exports = __webpack_public_path__ + "static/media/12-Y.7d39cd8f.mp3";